export const lockScroll = (): void => document.getElementsByTagName('html')[0].classList.add('locked')

export const unlockScroll = (): void => document.getElementsByTagName('html')[0].classList.remove('locked')
